const jquery = require('jquery');
window.$ = jquery;
window.jQuery = jquery;
